document.addEventListener("DOMContentLoaded", function () {
	const tiltElements = document.querySelectorAll(".hover-tilt-3d");

	tiltElements.forEach((element) => {
		const tiltAmount = element.dataset.tiltAmount || 10;
		let isHovering = false;

		const lerp = (start, end, factor) => {
			return start + (end - start) * factor;
		};

		let currentRotateX = 0;
		let currentRotateY = 0;
		let currentScale = 1;
		let targetRotateX = 0;
		let targetRotateY = 0;
		let targetScale = 1;
		let rafId = null;

		function updateTransform() {
			if (
				!isHovering &&
				Math.abs(currentRotateX) < 0.01 &&
				Math.abs(currentRotateY) < 0.01 &&
				Math.abs(currentScale - 1) < 0.001
			) {
				currentRotateX = 0;
				currentRotateY = 0;
				currentScale = 1;
				element.style.transform =
					"perspective(1000px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)";
				cancelAnimationFrame(rafId);
				return;
			}

			currentRotateX = lerp(currentRotateX, targetRotateX, 0.1);
			currentRotateY = lerp(currentRotateY, targetRotateY, 0.1);
			currentScale = lerp(currentScale, targetScale, 0.1);

			element.style.transform = `
          perspective(1000px)
          rotateX(${currentRotateX}deg)
          rotateY(${currentRotateY}deg)
          scale3d(${currentScale}, ${currentScale}, ${currentScale})
        `;

			rafId = requestAnimationFrame(updateTransform);
		}

		element.addEventListener("mousemove", (e) => {
			if (!element.classList.contains("hover-tilt-3d")) return;

			const rect = element.getBoundingClientRect();
			const x = e.clientX - rect.left;
			const y = e.clientY - rect.top;

			const xPercent = (x / rect.width - 0.5) * 2; // -1 to 1
			const yPercent = (y / rect.height - 0.5) * 2; // -1 to 1

			targetRotateX = yPercent * -tiltAmount;
			targetRotateY = xPercent * tiltAmount;
			targetScale = 1.02;

			if (!isHovering) {
				isHovering = true;
				rafId = requestAnimationFrame(updateTransform);
			}
		});

		element.addEventListener("mouseleave", () => {
			isHovering = false;
			targetRotateX = 0;
			targetRotateY = 0;
			targetScale = 1;
		});

		// Clean up
		return () => {
			if (rafId) {
				cancelAnimationFrame(rafId);
			}
		};
	});
});
